export default __webpack_public_path__ + "static/media/lookup-logo_search.57b6307f.svg";